import React from 'react';
import { colors2, UI_CAPTION_DF } from 'oolib';
import { ButtonGhost } from 'oolib/dist/v2/components/Buttons';
import styled from 'styled-components';
import { ReportsLightboxInput } from '../../WidgetBarChart/WIDGET_ELEM_ConfigForm';

const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
`;

const StyledLetterLabel = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const StyledFieldWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

/**
 * DataFieldRow - Single row in data fields list
 *
 * @param {String} letter - "A", "B", "C", etc.
 * @param {Object} field - Selected field object or null
 * @param {Array} options - Available options (all for A, NumberInput-only for B+)
 * @param {Function} onChange - Callback when field changes
 * @param {Function|null} onRemove - Callback to remove (null for A - can't remove)
 * @param {Boolean} disabled - Whether disabled
 */
export const DataFieldRow = ({
  letter,
  field,
  options,
  onChange,
  onRemove,
  disabled,
  picker
}) => {
  return (
    <StyledRow>
      <StyledLetterLabel>
        <UI_CAPTION_DF style={{ color: colors2.grey60 }}>{letter}</UI_CAPTION_DF>
      </StyledLetterLabel>

      <StyledFieldWrapper>
        <ReportsLightboxInput
          id={`field-${letter}`}
          options={options}
          value={field}
          onChange={(_, v) => onChange(v)}
          disabled={disabled}
          placeholder="Select field"
          picker={picker}
        />
      </StyledFieldWrapper>

      {onRemove && (
        <ButtonGhost
          icon="X"
          onClick={onRemove}
          disabled={disabled}
        />
      )}
    </StyledRow>
  );
};

export default DataFieldRow;
